import 'reflect-metadata';

import { promises as fs } from 'fs';
import path from 'path';
import { Component, Fragment } from 'react';

import { ROUTE_TO_COMPONENT_MAP } from '../components/route-to-component-map';
import { RouteProps } from '../types/route-types';
import SinglePageBaseComponent from '../components/single-page-converters/single-page-base.component';

async function getAllFilePaths(postsDirectory: string, urlSet: Set<string>) {
    const paths = await fs.readdir(postsDirectory);
    for (const _path of paths) {
        const fullPath = path.join(postsDirectory, _path);
        const stats = await fs.stat(fullPath);
        if (stats.isDirectory()) {
            getAllFilePaths(fullPath, urlSet);
        } else {
            urlSet.add(fullPath);
        }
    }
}

export async function getStaticPaths() {
    const postsDirectory = path.join(process.cwd(), '/ssr-data/routes/build/data/xconvert.com/')
    const allFilePaths = new Set<string>();
    await getAllFilePaths(postsDirectory, allFilePaths);
    const allowedPaths = [
        new RegExp('.*', 'i'),
    ];
    const disallowedList = [
        /root/i,
        /test/i,
        /faq\//i,
        /product\//i,
        /invalid-path/i
    ];
    const filterFn = (urlPath: string, matchers: RegExp[]) => {
        return matchers.find(p => urlPath.match(p));
    };
    const paths = Array.from(allFilePaths)
        .filter(p => filterFn(p, allowedPaths))
        .filter(p => !filterFn(p, disallowedList))
        .map(path => {
            const urlPath = path.replace(postsDirectory, '').replace('.json', '');
            return { params: { feature: urlPath } };
        });
    return {
        paths:
            paths,
        // [
        //     { params: { feature: 'compress-mp4' } } // See the "paths" section below
        // ],
        fallback: false // See the "fallback" section below
    };
}

export async function getStaticProps({ params }) {
    const props = `/home/user/sites/ps2pdf/ps2pdf-web/ssr-data/routes/build/data/xconvert.com/${params.feature}.json`;
    // console.log(`getStaticProps called for ${params.feature}`);
    const data = await fs.readFile(props);
    const jObj = JSON.parse(data.toString());
    // Pass post data to the page via props
    return { props: jObj };
}

export default class FeaturePage extends Component<RouteProps> {

    constructor(props) {
        super(props);
    }

    render() {
        const Comp = ROUTE_TO_COMPONENT_MAP[this.props.path];
        return <Comp key={this.props.path} {...this.props}></Comp>;
    }
}